var map = {
	"./kid10.png": 2909,
	"./kid11.png": 86228,
	"./kid12.png": 60719,
	"./kid13.png": 21702,
	"./kid14.png": 54745,
	"./kid15.png": 48496,
	"./kid16.png": 36139,
	"./kid17.png": 15010,
	"./kid18.png": 93189,
	"./kid19.png": 26652,
	"./kid20.png": 38904,
	"./kid21.png": 23521,
	"./kid22.png": 74538,
	"./kid23.png": 13395,
	"./kid24.png": 29788,
	"./kid25.png": 59205,
	"./kid26.png": 71054,
	"./kid7.png": 51759,
	"./kid8.png": 60600,
	"./kid9.png": 81729,
	"./kidandinstructor.png": 14326,
	"./kidimg.png": 97069,
	"./kids-on-book.png": 64283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10509;